import { styled } from '@eneco/sparky/stitches';

export const DateInputWrapper = styled('div', {
  padding: '$3',
  borderRadius: '$s',
  backgroundColor: '$backgroundPrimary',
  border: '$borderWidths$s solid $formBorderDefault',
  position: 'relative',

  '&:focus-within': {
    outline: '$outlineInputFocus',
    borderColor: '$borderFocus',
  },

  '&:hover': {
    boxShadow: '$shadowHover',
    borderColor: '$formBorderHover',
  },
});

export const DateInput = styled('input', {
  width: '100%',
  fontSize: '$BodyL',
  border: 'none',
  color: '$textPrimary',
  backgroundColor: 'transparent',

  '&::placeholder': {
    color: '$textLowEmphasis',
  },

  '&:focus': {
    outline: 'none',
  },

  '&:disabled': {
    cursor: 'not-allowed',
  },
});
